<script lang="ts">
  interface Props {
    variant?: "primary" | "secondary";
    class?: string;
    children?: import("svelte").Snippet;
  }

  let { variant = "secondary", class: className, children }: Props = $props();
</script>

<span
  class="{className} text-S block {variant == 'primary' ? 'text-Neutral900' : 'text-Neutral700'} "
  >{@render children?.()}</span
>
